/**
 * @group Network
@summary HTTP methods for API routes

@remarks
This constant contains standard HTTP methods used in API routes
for defining the allowed HTTP verbs for each endpoint.

@example
```typescript
import { HTTP_METHODS } from '@shared/constants';

if (req.method !== HTTP_METHODS.POST) {
  return res.status(405).json({ error: 'Method not allowed' });
}
```
 * @internal
 */
export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
  HEAD: 'HEAD',
  OPTIONS: 'OPTIONS'
} as const; 